import axios from 'axios'
import url from './Url'

class Pedido extends url {
    constructor() {
        super()
    }

    addCarrinho = (Company_ID, valorTotal, arrayCar) => {

        const cleanedArrayCar = arrayCar.map(item => {
            const { product, ...rest } = item;
            return rest;
        });
        const newData = { Company_ID, valorTotal, arrayCar: cleanedArrayCar };

        return axios.post(`${this.url()}/pedido-carrinho`, newData)
            .then(response => {
                return response;
            })
            .catch(err => {
                console.error("Erro ao adicionar ao carrinho:", err);
                return err;
            });
    };
    getPedido = (idUser, num, selectedTab) => {

        return axios.get(`${this.url()}/pedido/${idUser}/${num}?filter=${selectedTab}`)
            .then(pedido => {
                return pedido
            })
            .catch(err => {
                return err
            })
    };
    addPedido = (data) => {

        return axios.post(`${this.url()}/pedido`, data)
            .then(pedido => {
                return pedido
            })
            .catch(err => {
                return err
            })
    };
    cancelamento = () => {
        return axios.get(`${this.url()}/pedido-cancelamento`)
            .then(response => {
                return response
            })
            .catch(err => {
                return err
            })
    };

    /*  pedidos novos */

    getAllOrder = async (Company_ID, dataInicial, dataFinal, axiosConfig) => {
        try {
            const result = await axios.get(`${this.url()}/user-pendent/${Company_ID}?dataInicial=${dataInicial}&dataFinal=${dataFinal}`, axiosConfig)
            return result
        } catch (err) {
            return err
        }
    };
    getAllOrderAprovad = async (Company_ID, dataInicial, dataFinal, axiosConfig) => {
        try {
            const result = await axios.get(`${this.url()}/user-aprovad/${Company_ID}?dataInicial=${dataInicial}&dataFinal=${dataFinal}`, axiosConfig)
            return result
        } catch (err) {
            return err
        }
    };
    getAllOrderFatured = async (Company_ID, dataInicial, dataFinal, axiosConfig) => {
        try {
            const result = await axios.get(`${this.url()}/user-fatured/${Company_ID}?dataInicial=${dataInicial}&dataFinal=${dataFinal}`, axiosConfig)
            return result
        } catch (err) {
            return err
        }
    };
    getAllOrderEnviado = async (Company_ID, dataInicial, dataFinal, axiosConfig) => {

        try {
            const result = await axios.get(`${this.url()}/user-enviado/${Company_ID}?dataInicial=${dataInicial}&dataFinal=${dataFinal}`, axiosConfig)
            return result
        } catch (err) {
            return err
        }
    };

    getAllOrderFinalizado = async (Company_ID, dataInicial, dataFinal, axiosConfig) => {
        try {
            const result = await axios.get(`${this.url()}/user-finalizado/${Company_ID}?dataInicial=${dataInicial}&dataFinal=${dataFinal}`, axiosConfig)
            return result
        } catch (err) {
            return err
        }
    };
    getAllOrderCancelado = async (Company_ID, dataInicial, dataFinal, axiosConfig) => {
        try {
            const result = await axios.get(`${this.url()}/user-cancelado/${Company_ID}?dataInicial=${dataInicial}&dataFinal=${dataFinal}`, axiosConfig)
            return result
        } catch (err) {
            return err
        }
    };

}

export default Pedido;